function changeCountry(id) {
    $.ajax({
        url: '/zmena-krajiny',
        type: 'POST',
        dataType: 'json',
        data: { country_id: id },
    }).done(function(data) {
        Eshop.alert(data.msg, {
            'type': data.status ? 'success' : 'error'
        });
        location.reload();
    });
}

// change event for select
$('.js-trigger-country-change').on('change', function() {
    const selectValue = $(this).val();
    const optionUrl = $(this).find(`option[value="${selectValue}"]`).data('url');

    if (optionUrl !== undefined && optionUrl !== '') {
        window.location.href = optionUrl;
    } else {
        changeCountry(selectValue);
    }
});

// click event for buttons
$('.js-trigger-country-change-link').on('click', function() {
    const countryId = $(this).data('id');

    changeCountry(countryId);
});